import React from 'react';

import { useContext as useUsersContext } from 'components/Users/Context';

import { Link } from 'react-router-dom';
import routes from 'app/routes';

export default function LoginInfo() {
  const { state: stateUsers } = useUsersContext();

  return (
    <>
      <h4>Login Info</h4>
      <div className="mb-3 row">
        <div className="col-lg-6 mt-2">
          <b>Your email address:</b>
          <p>{stateUsers.user.attributes.email}</p>
          {stateUsers.user.attributes.is_mobile_login
            && <p>To update your email please visit the LeggUP web app.</p>}
        </div>
        <div className="col-lg-6 mt-2">
          <div className="d-flex justify-content-between justify-content-lg-end gap-2">
            {!stateUsers.user.attributes.is_mobile_login && (
            <Link
              to={routes.members.settings.emailUpdate}
              className="btn btn-outline-primary"
            >
              Change Email
            </Link>
            )}
            <Link
              to={routes.members.settings.passwordUpdate}
              className="btn btn-outline-primary"
            >
              Change Password
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
